<template lang="pug">
  section(class="bg-light-blue pad-y-70 text-center doa text-white")
    .container(style="position: relative")
      div(class="font-origano" style="font-size: 1.5rem") "Om iha iva stam ma viyaustam visvam ayur vyasnutam krisdantau putrair naptrbhih modamanau sve grhe"
      div(class="font-origano pad-bottom-90" style="font-size: .9rem") (Reg Weda X.85.42)

      div(style="line-height: 1.5rem; font-size: .95rem") Ya Tuhanku Yang Maha Pengasih, anugrahkanlah kepada pasangan suami-istri ini senantiasa berbahagia, keduanya tiada terpisahkan, panjang umur, semoga dianugrahkan putra dan cucu yang memberikan hiburan, tinggal di rumah yang penuh kebahagiaan
 
</template>

<script>
export default {};
</script>

<style scoped>
  .doa {
    background-image: url("https://ik.imagekit.io/aryraditya/surya-febi/CAR_7079__1__m-TWJs688.jpg?tr=e-grayscale");
    background-position: top center;
    background-attachment: fixed;
    position: relative;
  }

  .doa:before {
    background: #000;
    opacity: .55;
    width: 100%;
    height: 100%;
    position: absolute;
    content: ' ';
    left: 0;
    top: 0;
  }
</style>